import { FC } from 'react';
import {
  FilterSection,
  ColumnDateFilter,
  ColumnMultiSelectFilter,
} from 'components/data-table';
import type { ExpenseScenarioFacets } from './types';
import styles from './expense-scenarios-filters.module.scss';

interface ExpenseScenariosFiltersProps {
  facets: ExpenseScenarioFacets | undefined;
}

const ExpenseScenariosFilters: FC<ExpenseScenariosFiltersProps> = ({
  facets,
}) => {
  const toOptions = (items: { id: string; value: string }[] | undefined) =>
    (items ?? []).map((item) => ({ value: item.id, label: item.value }));

  return (
    <div className={styles.filtersWrapper}>
      <FilterSection title="Date Filters">
        {/* autoComplete is off on all three: the browser's autofill dropdown
            covers the calendar popover, and there is no reason it would apply
            to one of these date ranges but not the others. */}
        <ColumnDateFilter
          columnId="effectiveDate"
          label="Effective Date"
          autoComplete={false}
        />
        <ColumnDateFilter
          columnId="createdAt"
          label="Created At"
          autoComplete={false}
        />
        <ColumnDateFilter
          columnId="updatedAt"
          label="Updated At"
          autoComplete={false}
        />
      </FilterSection>

      <FilterSection title="People Filters">
        <ColumnMultiSelectFilter
          columnId="createdBy"
          label="Created By"
          options={toOptions(facets?.createdByOptions)}
        />
      </FilterSection>
    </div>
  );
};

export { ExpenseScenariosFilters };
